import React from 'react';
import { useDrag } from 'react-dnd';

function TreatmentPlan() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'treatment_plan' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }} className="card mb-2">
    <div className="card-body p-2 bg-white">
      Treatment Plan
    </div>
  </div>;
}

function PhysicalExam() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'physical_exam' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }} className="card mb-2">
    <div className="card-body p-2 bg-white">
      Physical Exam
    </div>
  </div>
}

function StudiesImaging() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'studies_imaging' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }} className="card mb-2">
    <div className="card-body p-2 bg-white">
      Studies/Imaging
    </div>
  </div>
}

function Dialogue() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'dialogue' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }} className="card mb-2">
    <div className="card-body p-2 bg-white">
      Additional Dialogue
    </div>
  </div>;
}

function Diagnosis() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'diagnosis' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }} className="card mb-2">
    <div className="card-body p-2 bg-white">
      Diagnosis
    </div>
  </div>;
}

function DocumentEncounter() {
  return <>
    <PhysicalExam />

    <StudiesImaging />

    <Diagnosis />

    <TreatmentPlan />

    <Dialogue />
  </>
}

export default DocumentEncounter;